function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "train@2x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "All-other-redesigns",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Listing-detail-view-(mover)",
  transform: "translate(-455.000000, -1405.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location-block",
  transform: "translate(53.000000, 1106.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "train",
  transform: "translate(402.000000, 299.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Combined-Shape-Copy-12",
  fill: "#8396C8",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,5.40625 C15.03875,5.40625 17.5,5.75 17.5,8.15625 L17.5,14.6875 C17.5,16.014375 16.420625,17.09375 15.09375,17.09375 L16.125,18.125 L16.125,18.46875 L14.75,18.46875 L13.375,17.09375 L10.783125,17.09375 L9.408125,18.46875 L7.875,18.46875 L7.875,18.125 L8.90625,17.09375 C7.579375,17.09375 6.5,16.014375 6.5,14.6875 L6.5,8.15625 C6.5,5.75 9.25,5.40625 12,5.40625 Z M8.90625,15.71875 C9.476875,15.71875 9.9375,15.258125 9.9375,14.6875 C9.9375,14.116875 9.476875,13.65625 8.90625,13.65625 C8.335625,13.65625 7.875,14.116875 7.875,14.6875 C7.875,15.258125 8.335625,15.71875 8.90625,15.71875 Z M11.3125,10.90625 L11.3125,8.15625 L7.875,8.15625 L7.875,10.90625 L11.3125,10.90625 Z M12.6875,10.90625 L16.125,10.90625 L16.125,8.15625 L12.6875,8.15625 L12.6875,10.90625 Z M15.09375,15.71875 C15.664375,15.71875 16.125,15.258125 16.125,14.6875 C16.125,14.116875 15.664375,13.65625 15.09375,13.65625 C14.523125,13.65625 14.0625,14.116875 14.0625,14.6875 C14.0625,15.258125 14.523125,15.71875 15.09375,15.71875 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
})))));

var SvgTrain = function SvgTrain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/train.cf09074d.svg";
export { ForwardRef as ReactComponent };